<template>
    <div v-if="!!post">
        <div class="entry-heading">
            <div class="wrapper">
                <a :href="'/'+ lang +'/supports'" class="entry-heading__back hidden-xs">
                    {{trans.text.pages.back}}
                </a>
                <div class="entry-heading__title">
                    <h1>{{getPostTitle}}</h1>
                </div>
                <div class="entry-heading__descr" v-html="getPostDescription">
<!--                    <p>{{getPostDescription}}</p>-->
                </div>
            </div>
        </div>

        <div class="entry-body">
            <template v-for="section in sections">

                <div class="wrapper" v-if="section.type === 'text' && section.style === 'main-text'">
                    <p class="mb-2x" v-html="section.content"></p>
                </div>

                <div class="wrapper" v-if="section.type === 'text' && section.style === 'heading'">
                    <h3 v-html="section.content"></h3>
                </div>

                <div class="wrapper" v-if="section.type === 'text' && section.style === 'green-descriptor'">
                    <h3 class="tac green" v-html="section.content"></h3>
                </div>

                <div class="entry-body-wide" v-if="section.type === 'text' && section.style === 'grey-descriptor'">
                    <div class="wrapper">
                        <p v-html="section.content"></p>
                    </div>
                </div>

                <div class="entry-gallery" v-if="section.type === 'image' && section.images.length > 0">
                    <div class="entry-gallery__list">
                        <div class="entry-gallery__col" v-for="image in section.images">
                            <img :alt="getPostTitle" :src="image"/>
                        </div>
                    </div>
                </div>

                <div class="entry-gallery" v-if="section.type === 'video' && !!section.video">
                    <video :src="section.video" autoplay="false" controls="controls" preload="auto"></video>
                </div>
            </template>

        </div>

        <div class="entry-news" v-if="similarNews.length > 0">
            <div class="wrapper">
                <div class="news-list news-list--col4">

                    <div class="news-card__col" v-for="post in similarNews">
                        <a :href="getPostLink(post)" class="news-card__item" tag="a">
                            <div class="news-card__image">
                                <img :alt="getSimilarPostTitle(post)" :src="getArticleImage(post)"/>
                            </div>
                            <div class="news-card__text">
                                <h4>{{getSimilarPostTitle(post)}}</h4>
                                <p>{{getSimilarPostDescription(post)}} </p>
                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        props: ['cat_slug', 'article_slug', 'lang', 'trans'],
        name: "SupportComponent",
        data() {
            return {
                post: null
            }
        },
        mounted() {
            this.loadPost(this.article_slug);
        },
        methods: {
            ...mapActions(['getSupportBySlug']),
            loadPost(slug) {
                let ctx = this;
                this.getSupportBySlug({
                    path: this.$path,
                    slug: slug
                }).then(post => {
                    ctx.post = post;
                }).catch(e => {
                    alert(e);
                });
            },
            getPostLink(post) {
                if (!!post.slug) {
                    return `/${this.lang}/support/${this.cat_slug}/${post.slug}`
                }
                return null;
            },
            getSimilarPostTitle(post) {
                if (post.title.length < 15) {
                    return post.title;
                }
                return `${post.title.substring(0, 15)}..`;
            },
            getSimilarPostDescription(post) {
                if (post.desc.length < 25) {
                    return post.desc;
                }
                return `${post.desc.substring(0, 25)}..`;
            },
            getArticleImage(post) {
                return `/storage/${post.images[0].image}`
            }
        },
        computed: {
            sections() {
                if (!!this.post) {
                    let language = this.lang;
                    return JSON.parse(this.post[language].full_desc);
                }
                return [];
            },
            similarNews() {
                let prefix;
                let language = this.lang;
                prefix = language + '_';
                if (language === 'en') {
                    prefix = '';
                }
                if (this.post[`${prefix}similar_support`].length > 0) {
                    return this.post[`${prefix}similar_support`]
                }
                return [];
            },
            getPostTitle() {
                let language = this.lang;
                return this.post[language].title;
            },
            getPostDescription() {
                let language = this.lang;
                return this.post[language].desc;
            }
        },
        watch: {
            article_slug: {
                handler: function (slug) {
                    if (slug !== this.post.slug) {
                        this.loadPost(slug);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
